/** Shared shimmer sweep for gallery skeletons — calm, single soft highlight pass. */
export const SHIMMER_KEYFRAMES = {
  '@keyframes gallerySkeletonShimmer': {
    '0%': { transform: 'translateX(-120%)' },
    '100%': { transform: 'translateX(120%)' },
  },
};

/** Sweep overlay as a sx `&::after` fragment. `quiet` softens + slows it for load-more tiles. */
export const shimmerAfterSx = (delaySeconds = 0, quiet = false) => ({
  content: '""',
  position: 'absolute' as const,
  inset: 0,
  background: `linear-gradient(105deg, transparent 25%, rgba(29, 155, 240, ${
    quiet ? 0.035 : 0.06
  }) 45%, rgba(231, 233, 234, ${quiet ? 0.05 : 0.09}) 50%, rgba(29, 155, 240, ${
    quiet ? 0.035 : 0.06
  }) 55%, transparent 75%)`,
  transform: 'translateX(-120%)',
  animation: `gallerySkeletonShimmer ${quiet ? '1.8s' : '1.4s'} ease-in-out infinite`,
  animationDelay: `${delaySeconds}s`,
  pointerEvents: 'none' as const,
});
